import type { SelectOption } from '@src/components/CommonSelect.types'
import type { Env } from '@src/config/apollo/api'

type EndpointSelectOption = Omit<SelectOption, 'value'> & { value: Env }
type GetEndpointSelectItems = (isDevelopmentBuild: boolean) => EndpointSelectOption[]

const allEndpointSelectItems: EndpointSelectOption[] = [
  { text: 'Production', value: 'production' },
  { text: 'Staging', value: 'staging' },
  { text: 'Development', value: 'development' },
]

export const getEndpointSelectItems: GetEndpointSelectItems = (isDevelopmentBuild) => {
  if (!isDevelopmentBuild) {
    return allEndpointSelectItems
  }

  return allEndpointSelectItems.filter(({ value }) => value !== 'production')
}
